import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorContentBlogSearch = () => {
  const blogSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/content-blog/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { blogSearch }
}

export default InteractorContentBlogSearch
